module.exports = __webpack_public_path__ + "static/desktop/img/turning.2d5caed8.gif";